import React, { useEffect, useState } from 'react';

import { useParams } from 'react-router-dom';

import './StreamOverlay.css';

const StreamOverlay = (props) => {
	let { streamType, streamKey } = useParams();
	// Types are 'fullscreen', 'popup', 'alert', 'spot'

	const [cacheBust, setCacheBust] = useState(new Date().getTime());
	const [scale, setScale] = useState(window.innerWidth / 1920);
	useEffect(() => {
		// reload iframes every 12h so people who never close OBS still get new versions
		const timer = setInterval(() => setCacheBust(new Date().getTime()), 12 * 60 * 60 * 1000);
		const resized = () => setScale(window.innerWidth / 1920);
		window.addEventListener('resize', resized);
		return () => {
			clearInterval(timer);
			window.removeEventListener('resize', resized);
		};
	}, []);

	document.body.style.setProperty('background-color', 'rgb(0, 0, 0)', 'important');
	document.body.style.setProperty('background', 'rgba(0, 0, 0, 0)', 'important');

	if (streamType === 'alert') {
		return (
			<iframe
				scrolling="no"
				className="stream-overlay-iframe"
				style={{
					transform: `scale(${scale})`,
				}}
				src={`${window.location.origin}/stream-elements/${streamKey}?cacheBust=${cacheBust}&${window.location.search.replace('?', '')}`}
				{...props}
				allow="autoplay *; encrypted-media *;"
				title="StreamOverlayAlert"
			></iframe>
		);
	} else {
		return (
			<iframe
				scrolling="no"
				className="stream-overlay-iframe"
				style={{
					transform: `scale(${scale})`,
				}}
				src={`${window.location.origin}/stream-frame/${streamType}/${streamKey}?cacheBust=${cacheBust}&${window.location.search.replace('?', '')}`}
				{...props}
				allow="autoplay *; encrypted-media *;"
				title="StreamOverlay"
			></iframe>
		);
	}
};

export default StreamOverlay;
